"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_NUM_SCAN_PLAN = exports.MAX_DAILY_SCAN_LIMIT = void 0;
/**
 * Maximum number of scans a user can perform per day (in their timezone)
 *
 * This limit prevents abuse and manages AI processing costs.
 * The limit resets at midnight in the user's local timezone.
 * Only 'completed' and 'processing' scans count towards this limit.
 * Failed scans do not count, allowing users to retry.
 */
exports.MAX_DAILY_SCAN_LIMIT = 1;
/**
 * Minimum number of scans a user can have in their scan plan
 * This is the minimum number of scans a user can have in their scan plan
 * to be eligible for the scan plan feature
 */
exports.MIN_NUM_SCAN_PLAN = 3;
//# sourceMappingURL=scan.js.map